module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-section__column-manage-spacings order-manage-spacings order-manage-spacings-top-bottom"
  }, [_c('div', {
    staticClass: "content plugin text-plugin text-container"
  }, [_c('h2', [_vm._v("Fehler beim Übermitteln der Bestellung")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "order-address-form__link--before",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Zurück\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Deine Bestellung konnte nicht übermittelt werden."), _c('br'), _vm._v("\n            Bitte versuche es später noch einmal oder kontaktiere uns per Telefon oder E-Mail:\n            "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+41438186152"
    }
  }, [_vm._v("043 818 61 52")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@oepfelchasper.ch"
    }
  }, [_vm._v("info@oepfelchasper.ch")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d558be6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Checkout/Error.vue
// module id = 871
// module chunks = 0